import Header from '@/layout/components/header.vue';
export default {
  name: 'Index',
  components: {
    Header: Header
  },
  data: function data() {
    return {
      hiddenGlobalNav: false
    };
  },
  mounted: function mounted() {
    this.hiddenGlobalNav = sessionStorage.getItem('hiddenGlobalNav');
  },
  methods: {
    backtopHover: function backtopHover() {
      // this.right = 18
    },
    backtopBlur: function backtopBlur() {
      // this.right = -21
    }
  }
};